import React from 'react';
import PropTypes from 'prop-types';

import StarEmpty from '../../../assets/star-empty-gray.svg';
import StarFilled from '../../../assets/star-filled-gray.svg';
import StarHalfFilled from '../../../assets/star-halffilled-gray.svg';

const LineOfStars = ({ value }) => {
  if (Number.isNaN(Number.parseFloat(value))) {
    return null;
  }
  const STARS_TOTAL_COUNT = 5;
  let result;
  const filledStars = Number.parseInt(value, 10);
  result = new Array(filledStars);
  result.fill(<StarFilled />, 0, filledStars);
  const halfFilledStar = value - filledStars;
  if (halfFilledStar) result.push(<StarHalfFilled />);
  if (result.length < STARS_TOTAL_COUNT) {
    const emptyStars = Math.floor(STARS_TOTAL_COUNT - value);
    result = result.concat((new Array(emptyStars)).fill(<StarEmpty />, 0, emptyStars));
  }

  return result;
};

LineOfStars.propTypes = { value: PropTypes.number };
LineOfStars.defaultProps = { value: null };

export default LineOfStars;
